import React from "react";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";

function Modal({ positionVal }) {
  let [jobOpening, setJobOpening] = useState([]);
  const [success, setSuccess] = useState(false);
  async function handleSubmit(e) {
    e.preventDefault();
    let data = new FormData();

    const formData = {
      email: e.target.email.value,
      name: e.target.name.value,
      message: e.target.message.value,
      phone: e.target.phone.value,
      age: e.target.age.value,
      position: e.target.position.value,
    };

    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    if (e.target.cv.files.length > 0) {
      data.append("cv", e.target.cv.files[0]);
    }
    alert(e.target.cv.files[0]);
console.log(data);
console.log(formData);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/career`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Response Sent", response);
      e.target.reset();
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  return (
    <form onSubmit={handleSubmit} encType="multipart/form-data" className="">
      <ContactInputBox type="text" name="name" placeholder="Your Name" />
      <ContactInputBox type="text" name="email" placeholder="Your Email" />
      <ContactInputBox type="text" name="phone" placeholder="Your Phone" />
      <ContactInputBox type="text" name="age" placeholder="Your Age" />
      <select
        name="position"
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#173d73] focus:border-transparent mb-6"
      >
        <option value="">Select Position</option>
        {positionVal.map((position, index) => (
          <option key={index} value={position}>
            {position}
          </option>
        ))}
      </select>
      <ContactTextArea
        row="6"
        placeholder="Your Message"
        name="message"
        defaultValue=""
      />
      <div className="flex flex-col flex-1 mb-6">
        <label className="my-1 text-left text-gray-500" htmlFor="cv">
          Attach Your CV
        </label>
        <input
          type="file"
          name="cv"
          id="cv"
          className="w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:outline-none"
        />
      </div>
      <div>
        <button
          type="submit"
          className="w-full p-3 text-white transition bg-black border border-black rounded hover:bg-white hover:text-black"
        >
          Send Message
        </button>
      </div>
      {success && (
        <div
          style={{
            color: "white",
            background: "#173D73",
            marginTop: "10px",
          }}
        >
          ✔ Form submitted successfully!
        </div>
      )}
    </form>
  );
}

export default Modal;


const ContactTextArea = ({ row, placeholder, name, defaultValue }) => {
  return (
    <>
      <div className="mb-2">
        <textarea
          rows={row}
          placeholder={placeholder}
          name={name}
          className="w-full resize-none rounded border border-stroke px-[14px] py-3 text-base text-body-color outline-none focus:border-primary dark:border-dark-3 dark:bg-dark dark:text-dark-6"
          defaultValue={defaultValue}
        />
      </div>
    </>
  );
};

const ContactInputBox = ({ type, placeholder, name }) => {
  return (
    <>
      <div className="mb-2">
        <input
          type={type}
          placeholder={placeholder}
          name={name}
          className="w-full rounded border-b border-stroke px-[14px] py-3 text-base text-body-color outline-none focus:border-primary dark:border-dark-3 dark:bg-dark dark:text-dark-6"
        />
      </div>
    </>
  );
};
